import globalAPI from '@/api/globalAPI'
import orgManageAPI from '@/api/orgManageAPI'
import authAPI from './authAPI'
import dataSourceOrgAPI from '@/api/dataSourceOrgAPI'
import userManageAPI from '@/api/userManageAPI'
import sketchboardAPI from '@/api/sketchboardAPI'
import systemSettingAPI from '@/api/systemSettingAPI'
import orgSettingAPI from '@/api/orgSettingAPI'
import cryptoAPI from '@/api/cryptoLogin'

export {
  globalAPI as glbAPI,
  orgManageAPI,
  authAPI,
  dataSourceOrgAPI,
  userManageAPI,
  sketchboardAPI,
  systemSettingAPI,
  orgSettingAPI,
  cryptoAPI
}



// WEBPACK FOOTER //
// ./src/api/restfulAPI.js